<template>
  <div class="card">
    <div class="card-content">
      <form>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="number"
                      label="Id"
                      placeholder="Id"
                      v-model="user.id" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Registrierungsdatum"
                      placeholder=""
                      v-model="user.registration_date" readonly="readonly">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="email"
                      label="Email"
                      placeholder="Email"
                      v-model="user.email" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Zuletzt aktiv"
                      placeholder=""
                      v-model="user.last_active" readonly="readonly">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Name"
                      placeholder="Name"
                      v-model="user.nickname" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Avatar"
                      placeholder=""
                      v-model="user.avatar" readonly="readonly">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Push Notifications"
                      placeholder="Name"
                      v-model="user.push_notifications" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Push News"
                      placeholder=""
                      v-model="user.news_push_notifications" readonly="readonly">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Email Notifications"
                      placeholder="Name"
                      v-model="user.email_notifications" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Email News"
                      placeholder=""
                      v-model="user.news_email_notifications" readonly="readonly">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Source"
                      placeholder="Source"
                      v-model="user.source" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Adult"
                      placeholder=""
                      v-model="user.isadult" readonly="readonly">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label>Status</label>
            <select name="status" id="status"
                    v-model="user.status"
                    class="form-control" disabled="disabled">
              <option value="active">Aktiv</option>
              <option v-if="user.id > 0" value="validation_pending">Bestätigung offen</option>
              <option v-if="user.id > 0" value="password_reset">Passwort zurücksetzen</option>
            </select>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Sprache"
                      placeholder=""
                      v-model="user.lang" readonly="readonly">
            </fg-input>
          </div>
        </div>

      </form>

      <div class="row" style="margin-top: 20px;">
        <div class="col-sm-12">
          <label>Tokens</label>
          <el-table class="table-striped"
                    :data="queriedTokens"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in tokenColumns"
                             :key="column.label"
                             :align='column.align'
                             :class-name='column.class'
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="row" style="margin-top: 20px;">
        <div class="col-sm-12">
          <label>Apps</label>
          <el-table class="table-striped"
                    :data="queriedApps"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in appsColumns"
                             :key="column.label"
                             :align='column.align'
                             :class-name='column.class'
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="row" style="margin-top: 20px;">
        <div class="col-sm-12">
          <label>Tipprunden</label>
          <el-table class="table-striped"
                    :data="queriedBetgames"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in betgameColumns"
                             :key="column.label"
                             :align='column.align'
                             :class-name='column.class'
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="row" style="margin-top: 20px;">
        <div class="col-sm-12">
          <label>Erstellte Tipprunden</label>
          <el-table class="table-striped"
                    :data="queriedCreatedBetgames"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in betgameColumns"
                             :key="column.label"
                             :align='column.align'
                             :class-name='column.class'
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
          </el-table>
        </div>
      </div>


      <div v-if="isValidEmail(user.email) && user.id > 0" class="col-md-12" style="margin-top: 20px; margin-bottom: 30px; border-bottom: lightgray 2px solid">
      </div>

      <div v-if="isValidEmail(user.email) && user.status === 'validation_pending'" class="row" style="margin-top: 30px;">
        <div class="col-md-9">
          Registrierungs Email an {{ user.email }} senden
        </div>
        <div class="col-md-3">
          <div class="text-right">
            <button type="button" class="btn btn-info btn-fill btn-wd" @click.prevent="resendValidationEmail">
              Senden
            </button>
          </div>
        </div>
      </div>
      <div v-if="user.id > 0 && isValidEmail(user.email)" class="row" style="margin-top: 30px; margin-bottom: 30px;">
        <div class="col-md-9">
          Passwort zurücksetzen Email an {{ user.email }} senden
        </div>
        <div class="col-md-3">
          <div class="text-right">
            <button type="button" class="btn btn-info btn-fill btn-wd" @click.prevent="requestPasswordReset">
              Senden
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  export default {
    props: {
      id: {
        type: Number,
        default: () => {
          return 0
        }
      }
    },
    computed: {
      queriedCreatedBetgames () {
        return this.user.created_betgames
      },
      queriedBetgames () {
        if(this.user.betgames) {
          return this.user.betgames.sort((a, b) => {
            return b.id - a.id
          })
        }
        return []
      },
      queriedTokens () {
        return this.user.tokens
      },
      queriedApps () {
        return this.user.apps
      },
      title () {
        if (this.id === 0) {
          return 'Hinzufügen'
        }
        return 'Bearbeiten'
      },
      user () {
        if (this.id === 0) {
          return this.new_user
        }
        const user = this.$store.getters.getUserById(this.id)
        if (user.length > 0) {
          return user[0]
        }
        return {}
      }
    },
    data () {
      return {
        user_betgame_points: '',
        new_password: '',
        new_password_repeat: '',
        sendValidationEmailOnSave: false,
        new_user: {
          id: 0,
          nickname: '',
          email: '',
          source: '',
          address: '',
          zip: '',
          city: '',
          status: 'active',
          allow_email: false
        },
        appsColumns: [
          {
            prop: 'last_active',
            label: 'Aktiv',
            minWidth: 130
          },
          {
            prop: 'installation_date',
            label: 'Date',
            minWidth: 130,
            align: 'left',
            class: 'id-column'
          },
          {
            prop: 'os',
            label: 'OS',
            minWidth: 130
          },
          {
            prop: 'app_version',
            label: 'Version',
            minWidth: 130
          }
        ],
        betgameColumns: [
          {
            prop: 'id',
            label: 'Id',
            minWidth: 40,
            align: 'left',
            class: 'id-column'
          },
          {
            prop: 'name',
            label: 'Tipprunde',
            minWidth: 130
          },
          {
            prop: 'user_bets',
            label: 'Tipps',
            minWidth: 130
          }
        ],
        tokenColumns: [
          {
            prop: 'token_type',
            label: 'Type',
            minWidth: 60,
            align: 'left',
            class: 'id-column'
          },
          {
            prop: 'token',
            label: 'Token',
            minWidth: 130
          },
          {
            prop: 'created_at',
            label: 'Date',
            minWidth: 130
          },
        ]
      }
    },
    created () {
      if (this.$store.state.userBetgamePoints && this.user.id) {
        const ubp = this.$store.state.userBetgamePoints.filter(s => parseInt(s.fk_user) === parseInt(this.user.id))
        if (ubp.length === 1) {
          this.user_betgame_points = '' + ubp[0].points
        }
      }
    },
    methods: {
      requestPasswordReset () {
        this.$store.dispatch('requestPasswordReset', {
          email: this.user.email
        })
          .then(() => {
            alert('Email gesendet')
          })
      },
      resendValidationEmail () {
        this.$store.dispatch('resendValidationEmail', {
          email: this.user.email
        })
          .then(() => {
            alert('Email gesendet')
          })
      },
      deleteProfile () {
        this.$log.debug('deleteProfile ' + this.user.id)
        if (this.user.id > 0) {
          var r = confirm('Benutzer ' + this.user.nickname + ' (' + this.user.email + ') löschen?')
          if (r === true) {
            this.$store.dispatch('deleteUser', { user_id: '' + this.user.id, betgame_id: '' + this.$store.state.betgame })
              .then(response => {
                this.$router.push('/users')
              })
            /*
            this.$store.dispatch('updateUser', {
              id: this.user.id,
              content: {
                status: 'inactive'
              }
            }).then(() => {
              this.$router.push('/users')
            })
            */
          }
        }
      },
      updateProfile () {
        if (this.user.id === 0) {
          var valid = false
          if (!this.isNullOrUndefined(this.new_password) && this.new_password.length > 0) {
            if (!this.isNullOrUndefined(this.new_password_repeat) && this.new_password_repeat.length > 0) {
              if (this.new_password.toLowerCase() === this.new_password_repeat.toLowerCase()) {
                valid = true
              }
            }
          }
          if (this.isNullOrUndefined(this.user.nickname) || this.user.nickname.length === 0 || this.user.nickname.length > 100) {
            valid = false
          }
          if (!this.isValidEmail(this.user.email)) {
            valid = false
          }
          if (valid) {
            this.$store.dispatch('addUser', {
              nickname: this.user.nickname,
              email: this.user.email.toLowerCase(),
              password: this.new_password,
              status: this.user.status,
              source: this.user.source,
              address: this.user.address,
              zip: this.user.zip,
              city: this.user.city,
              allow_email: true,
              fk_betgame: this.$store.state.betgame,
              role: 'betgame_user',
              acceptedtos: true,
              push_notifications: false,
              email_notifications: false,
              isadult: true,
              lang: 'de',
              acceptedcop: true
            }).then((id) => {
              this.$router.push('/user/' + id)
            })
          } else {
            alert('Der Benutzer konnte nicht hinzugefügt werden.')
          }
        } else {
          this.$log.debug('updateProfile ' + this.new_password + ' --- ' + this.new_password_repeat)
          var updatePasswd = false
          if (!this.isNullOrUndefined(this.new_password) && this.new_password.length > 0) {
            if (!this.isNullOrUndefined(this.new_password_repeat) && this.new_password_repeat.length > 0) {
              if (this.new_password.toLowerCase() === this.new_password_repeat.toLowerCase()) {
                updatePasswd = true
              }
            }
          }
          if (updatePasswd) {
            this.$store.dispatch('updateUser', {
              id: this.user.id,
              content: {
                nickname: this.user.nickname, email: this.user.email, status: this.user.status, source: this.user.source, address: this.user.address, zip: this.user.zip, city: this.user.city, allow_email: this.user.allow_email, password: this.new_password
              }
            }).then(() => {
              alert('Benutzer-Daten wurden aktualisiert')
            })
          } else {
            this.$store.dispatch('updateUser', {
              id: this.user.id,
              content: {
                nickname: this.user.nickname, email: this.user.email, status: this.user.status, source: this.user.source, address: this.user.address, zip: this.user.zip, city: this.user.city, allow_email: this.user.allow_email
              }
            }).then(() => {
              alert('Benutzer-Daten wurden aktualisiert')
            })
          }
          if (this.$store.state.betgame === '1702' || this.$store.state.betgame === '1902') {
            if (this.user_betgame_points && parseInt(this.user_betgame_points) !== 0) {
              const data = {
                'fk_user': parseInt(this.user.id),
                'points': parseInt(this.user_betgame_points),
                'fk_betgame': parseInt(this.$store.state.betgame)
              }
              this.$store.dispatch('updateUserBetgamePoints', data).then(response => {
                if (response.status >= 200 && response.status <= 204) {
                } else {
                }
              }, error => {
                alert(error)
              })
            } else if (!this.user_betgame_points || this.user_betgame_points.trim().length === 0 || (this.user_betgame_points && parseInt(this.user_betgame_points) === 0)) {
              const data = {
                'fk_user': parseInt(this.user.id),
                'points': 0,
                'fk_betgame': parseInt(this.$store.state.betgame)
              }
              this.$store.dispatch('deleteUserBetgamePoints', data).then(response => {
                if (response.status >= 200 && response.status <= 204) {
                } else {
                }
              }, error => {
                alert(error)
              })
            }
          }
        }
        // alert('Your data: ' + JSON.stringify(this.user))
      },
      isNullOrUndefined (data) {
        return data === null || data === undefined
      },
      isValidEmail (email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(email).toLowerCase())
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGBackendEditUserForm.vue